import { SET_USER_SEARCH, SET_USER_RESULT, RESET_USER_SEARCH } from "@redux/constants";

const initialState = {
    userSearchEmail: "",
    users: [],
    selectedUser: null,
    didUpdateInitialCredentials: false,
    email: process.env.NEXT_PUBLIC_TEST_USER_SEARCH || "",
    id: "",
    phoneNumber: "",
    tempAuthCode: "",
    appleTransactions: [],
    deviceTokens: [],
    fulfilledPromotions: [],
    gender: "",
    genderPref: "",
    isEnabled: false,
    isAdmin: false,
    isOptedIntoMarketingEmails: false,
    language: "",
    seconds: 0,
    totalFreeMinutes: 0,
    totalMinutesBought: 0,
    totalSpent: 0,
    transactions: [],
    type: "",
    totalPaidAmount: 0,
    totalPaidSeconds: 0,
    totalFreeSeconds: 0,
    totalSecondsUsed: 0,
    avgSecondsUsedPerMonth: 0,
    totalRemainingSeconds: 0,
    username: "",
    subscription: undefined,
};

export const userSearchReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_USER_SEARCH:
            return {
                ...state,
                userSearchEmail: action.payload,
            };

        case SET_USER_RESULT: {
            const userPayload = Array.isArray(action.payload) ? action.payload[0] : action.payload;
            const previousUser = state.selectedUser;
            const identityChanged = Boolean(
                previousUser &&
                userPayload &&
                ((previousUser.id && userPayload.id && previousUser.id !== userPayload.id) ||
                    (previousUser.email && userPayload.email && previousUser.email !== userPayload.email))
            );
            const ratingFields = identityChanged
                ? {
                      rating: Object.prototype.hasOwnProperty.call(userPayload || {}, "rating")
                          ? userPayload.rating
                          : undefined,
                      userRating: Object.prototype.hasOwnProperty.call(userPayload || {}, "userRating")
                          ? userPayload.userRating
                          : undefined,
                      numberOfRatings: Object.prototype.hasOwnProperty.call(userPayload || {}, "numberOfRatings")
                          ? userPayload.numberOfRatings
                          : undefined,
                  }
                : {};
            const previousUserData = { ...((previousUser && previousUser.userData) || {}) };
            if (identityChanged) {
                delete previousUserData.rating;
                delete previousUserData.userRating;
                delete previousUserData.numberOfRatings;
            }

            return {
                ...state,
                users: Array.isArray(action.payload) ? action.payload : [action.payload],
                selectedUser: Array.isArray(action.payload)
                    ? {
                          ...state.selectedUser,
                          ...action.payload[0],
                          ...ratingFields,
                          isAdmin: Object.prototype.hasOwnProperty.call(action.payload[0] || {}, "isAdmin")
                              ? action.payload[0].isAdmin
                              : undefined,
                          username: Object.prototype.hasOwnProperty.call(action.payload[0] || {}, "username")
                              ? action.payload[0].username
                              : undefined,
                          subscription: Object.prototype.hasOwnProperty.call(
                              action.payload[0]?.userData || {},
                              "subscription"
                          )
                              ? action.payload[0].userData.subscription
                              : undefined,
                          userData: {
                              ...previousUserData,
                              ...((action.payload[0] && action.payload[0].userData) || {}),
                          },
                      }
                    : {
                          ...state.selectedUser,
                          ...action.payload,
                          ...ratingFields,
                          isAdmin: Object.prototype.hasOwnProperty.call(userPayload || {}, "isAdmin")
                              ? userPayload.isAdmin
                              : undefined,
                          username: Object.prototype.hasOwnProperty.call(userPayload || {}, "username")
                              ? userPayload.username
                              : undefined,
                          subscription: Object.prototype.hasOwnProperty.call(
                              userPayload?.userData || {},
                              "subscription"
                          )
                              ? userPayload.userData.subscription
                              : undefined,
                          userData: {
                              ...previousUserData,
                              ...((action.payload && action.payload.userData) || {}),
                          },
                      },
            };
        }

        case RESET_USER_SEARCH:
            return initialState;

        default:
            return state;
    }
};
